import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogosPLMService {

  path: string = '../../../assets/images/icon/';

  constructor() {
  }

  catalogoSINO() {
    return [
      {clave: 'NO', valor: 'NO'},
      {clave: 'SI', valor: 'SI'} 
    ];
  }

  plantillaCabecera() {
    let cabecera: any[] = [[
      'tipo',
      'grupo',
      'claseInspeccion',
      'descripcionTipoMaterial',
      'descripcionGrupo',
      'descripcionMacrocategoria',
      'gestionQm',
      'especificacionRdl',
      'instruccionProcesoClaseInsp03',
      'operacionesQmClaseInsp03',
      'aprovActivo',
      'claveQm',
      'tipoCoa',
      'puntoInspeccion',
      'tipoPuntoInspeccion',
      'pm0001Cuantitativa',
      'pm0002Cualitativa',
      'pm0003Cuantitativa',
      'pm0004Cualitativa',
      'pm0005Cuantitativa',
      'pm0006Cualitativa',
      'claseUtilizacion',
      'c1001A001',
      'c1001A002',
      'c1001A003',
      'c1001A004',
      'c1001A005',
      'c1001A006',
      'c1001A009',
      'c1002A001',
      'c1002A006',
      'c1002A007',
      'c1002A008',
      'c1002A009',
      'c2001A001',
      'c2001A010',
      'c3001A001',
      'c3001A012',
      'qm1001',
      'qm1002',
      'qm2001',
      'qm3001',
      'usuarioTransaccion'
    ]];

    return cabecera;
  }

  plantillaMockup() {
    let datosMockup: any[] = [
      {
        tipo: 'ZPTA',
        grupo: 'PTA01004',
        claseInspeccion: 'Z06',
        descripcionTipoMaterial: 'descripcionTipoMateria',
        descripcionGrupo: 'descripcionGrupo',
        descripcionMacrocategoria: 'descripcionMacrocategoria',
        gestionQm: 'SI',
        especificacionRdl: 'NO',
        instruccionProcesoClaseInsp03: 'NO',
        operacionesQmClaseInsp03: 'NO',
        aprovActivo: '',
        claveQm: 'Z9999',
        tipoCoa: 'ZE23',
        puntoInspeccion: '',
        tipoPuntoInspeccion: 'tipoPuntoInspeccion',
        pm0001Cuantitativa: 'PM001',
        pm0002Cualitativa: 'PM002',
        pm0003Cuantitativa: 'PM003',
        pm0004Cualitativa: 'PM004',
        pm0005Cuantitativa: 'PM005',
        pm0006Cualitativa: 'PM006',
        claseUtilizacion: 'clase de utilizacion',
        c1001A001: 'A001',
        c1001A002: 'A002',
        c1001A003: 'A003',
        c1001A004: 'A004',
        c1001A005: 'A005',
        c1001A006: 'A006',
        c1001A009: 'A009',
        c1002A001: 'A001',
        c1002A006: 'A006',
        c1002A007: 'A007',
        c1002A008: 'A008',
        c1002A009: 'A009',
        c2001A001: 'A001',
        c2001A010: 'A010',
        c3001A001: 'A001',
        c3001A012: 'A012',
        qm1001: 'X',
        qm1002: 'X',
        qm2001: 'X',
        qm3001: 'X',
        usuarioTransaccion: "se sobreescribe con el usuario actual"
      }
    ];

    return datosMockup;
  }

  catalogoClaseUtilizacion() {
    return [
      { clave: '3', valor: '3' },
      { clave: '5', valor: '5' },
      { clave: '6', valor: '6' },
      { clave: '9', valor: '9' },
      { clave: '51', valor: '51' },
      { clave: '', valor: 'No Aplica' },
    ];
  }

  catalogoClaseInspeccion() {
    return [
      { clave: '01', valor: '01' },
      { clave: '0101', valor: '0101' },
      { clave: '03', valor: '03' },
      { clave: '04', valor: '04' },
      { clave: '08', valor: '08' },
      { clave: '09', valor: '09' },
      { clave: '10', valor: '10' },
      { clave: '89', valor: '89' },
      { clave: 'Z04', valor: 'Z04' },
      { clave: 'Z06', valor: 'Z06' },
      { clave: 'Z89', valor: 'Z89' },
      { clave: '', valor: 'No Aplica' },
    ];
  }
  

}